import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@features/campaigns/shared/consts/apiRoutes';
import { mockedCampaignSubmitResponse } from '@shared/mocks/requests/campaignSubmit/campaignSubmit.fixtures';

export const campaignSubmitRequests = [
  http.post(`*${apiRoutes.submitCampaign(':campaignId')}`, () => {
    return HttpResponse.json(mockedCampaignSubmitResponse);
  }),
];
